export default __webpack_public_path__ + "static/media/Icon.6a714dde.png";